import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AssistantDemo } from '@/components/mcp/AssistantDemo';
import { CopyField } from '@/components/mcp/CopyField';
import { MCP_SERVER_URL } from '@/data/mcpContent';
import { Reveal, SectionHeading } from './primitives';

const points = [
  'Open and publish a role in one sentence',
  'Ask who’s new, who’s strongest and where the pipeline is stuck',
  'Move candidates and send invitations after you confirm',
];

/** Homepage: the agent can be run from Claude, ChatGPT or any MCP client. */
export function AssistantSection() {
  return (
    <section className="relative overflow-hidden bg-bv-ink py-24 text-white lg:py-32" aria-labelledby="assistant-title">
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="bv-grid-dark absolute inset-0" />
        <div className="absolute -left-40 top-10 h-[460px] w-[460px] rounded-full bg-[hsl(var(--blue)/0.24)] blur-[120px]" />
        <div className="absolute -right-40 bottom-0 h-[420px] w-[420px] rounded-full bg-[hsl(var(--hero-highlight-end)/0.18)] blur-[120px]" />
      </div>
      <div className="relative mx-auto grid max-w-[1240px] gap-14 px-5 lg:grid-cols-[0.85fr_1.15fr] lg:items-center lg:px-8">
        <div className="min-w-0">
          <SectionHeading tone="dark" id="assistant-title" eyebrow="New · Beatview MCP server" title={<>Run your desk from <span className="bv-hero-highlight">Claude, ChatGPT or Gemini.</span></>} description="Connect Beatview to the AI assistant you already use. Your agent keeps screening and interviewing in the background; the chat is where you check in and decide." />
          <Reveal delay={0.12}>
            <ul className="mt-8 space-y-3">
              {points.map(point => (
                <li key={point} className="flex gap-3 text-[16px] leading-7 text-white/80">
                  <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-bv-success"><Check className="h-3 w-3" strokeWidth={3} /></span>{point}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.18}>
            <CopyField value={MCP_SERVER_URL} label="Server" tone="dark" className="mt-9 max-w-md" />
            <p className="mt-3 text-[13px] text-white/50">Works with Claude, ChatGPT, Gemini, Cursor and other MCP-compatible tools — on every plan.</p>
            <Button asChild size="lg" className="bv-shine mt-8 h-[52px] rounded-xl px-6 text-base font-semibold">
              <Link to="/mcp">See what you can ask <ArrowRight className="h-4 w-4" /></Link>
            </Button>
          </Reveal>
        </div>
        <Reveal delay={0.1} className="min-w-0">
          <AssistantDemo compact tone="dark" />
        </Reveal>
      </div>
    </section>
  );
}
